module.exports = __webpack_public_path__ + "fonts/THIS_FONT_IS_BOLD.5a136e22.woff";